export default {"src":"/_next/static/media/relay-logo.cabccc81.svg","height":80,"width":77,"blurWidth":0,"blurHeight":0};